import React, { FunctionComponent, ComponentProps, useCallback } from 'react';
import { ButtonStandard, ButtonStandardType } from '../../button/ButtonStandard/ButtonStandard';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { IconDeprecated, IconType } from '../IconDeprecated/IconDeprecated';
import styles from './Pagination.module.css';
export type PaginationProps = ComponentProps<'div'> & {
  paginationHandle: PaginationHandle;
};
export const Pagination: FunctionComponent<PaginationProps> = React.memo(props => {
  const {
    paginationHandle,
    className,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const handleLeftClick = useCallback(() => {
    if (paginationHandle.page > paginationHandle.minPage) {
      paginationHandle.setPage(paginationHandle.page - 1);
    }
  }, [paginationHandle]);
  const handleRightClick = useCallback(() => {
    if (paginationHandle.page < paginationHandle.maxPage) {
      paginationHandle.setPage(paginationHandle.page + 1);
    }
  }, [paginationHandle]);
  const canNavigateLeft = paginationHandle.page > paginationHandle.minPage;
  const canNavigateRight = paginationHandle.page < paginationHandle.maxPage;
  return <div {...remainingProps} className={classes(className, styles.pagination)}>
        <div>
          <ButtonStandard type={ButtonStandardType.TextSecondary} disabled={!canNavigateLeft} onClick={handleLeftClick} data-testid="Pagination.LeftButton">
            <IconDeprecated name="angle-left" type={IconType.Light}></IconDeprecated>
          </ButtonStandard>
        </div>
        <div className={styles.pageNumber}>
          {paginationHandle.page} / {paginationHandle.maxPage}
        </div>
        <div>
          <ButtonStandard type={ButtonStandardType.TextSecondary} disabled={!canNavigateRight} onClick={handleRightClick} data-testid="Pagination.RightButton">
            <IconDeprecated name="angle-right" type={IconType.Light}></IconDeprecated>
          </ButtonStandard>
        </div>
      </div>;
});
export type PaginationHandle = {
  page: number;
  minPage: number;
  maxPage: number;
  setPage: (page: number) => void;
};